/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

// BootstrapVue
import { BootstrapVue } from 'bootstrap-vue'
Vue.use(BootstrapVue)

// Translation
Vue.mixin(require('./trans'))

// Moment Js
const moment = require('moment')
require('moment/locale/es')
require('moment/locale/pt-br')
Vue.use(require('vue-moment'), {
    moment
})

// Notifications
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';
Vue.use(VueToast, {
    position: 'top',
    duration: 5000
});

// Chart Morris
import Raphael from 'raphael/raphael'
global.Raphael = Raphael

// Chart Google
import VueGoogleCharts from 'vue-google-charts'
Vue.use(VueGoogleCharts)

// Forms
import { HasError, AlertError } from 'vform'
Vue.component(HasError.name, HasError)
Vue.component(AlertError.name, AlertError)

// Select Field
import vSelect from 'vue-select'
// import 'vue-select/dist/vue-select.css';
Vue.component('v-select', vSelect)

// Currency
import VueCurrencyInput from 'vue-currency-input'
Vue.use(VueCurrencyInput, {
    globalOptions: { currency: 'BRL'}
})

// Currency Filter
import VueCurrencyFilter from 'vue-currency-filter'
Vue.use(VueCurrencyFilter, {
    symbol : '&&',
    thousandsSeparator: '.',
    fractionCount: 2,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: true
})

// Main Filters
import Vue2Filters from 'vue2-filters'
Vue.use(Vue2Filters)

// Copy Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

Sentry.init({
  dsn: "https://3b54291494ce414dabb7d27e55bcbb46@o273238.ingest.sentry.io/6066446",
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

Vue.component('sidebar', require('./components/Layouts/Sidebar.vue').default);
Vue.component('change-date-tenant', require('./components/ChangeDateTenant.vue').default);
Vue.component('change-date-diary', require('./components/ChangeDateDiary.vue').default);

//Share result and ExportBets
Vue.component('share-result', require('./components/ShareResult.vue').default);
Vue.component('export-bets', require('./components/Export/Bets.vue').default);

// Home
Vue.component('chart-bankroll-history', require('./components/Home/ChartBankrollHistory.vue').default);
Vue.component('chart-profit-loss', require('./components/Home/ChartProfitLoss.vue').default);

// Bets
Vue.component('bets-create-bet', require('./components/Bets/CreateBet.vue').default);
Vue.component('bets-update-bet', require('./components/Bets/UpdateBet.vue').default);
Vue.component('bets-create-multiple-bet', require('./components/Bets/CreateMultipleBet.vue').default);
Vue.component('bets-update-multiple-bet', require('./components/Bets/UpdateMultipleBet.vue').default);
Vue.component('bets-update-pending-bet', require('./components/Bets/UpdatePendingBet.vue').default);

// Bets - Import
Vue.component('bets-import-results', require('./components/Bets/Import/ImportResults').default);

// Betfair
Vue.component('betfair-choose-bankroll', require('./components/Betfair/BetfairChooseBankroll').default);

// Transactions
Vue.component('transactions-create-withdrawal', require('./components/Transactions/CreateWithdrawal.vue').default);
Vue.component('transactions-create-deposit', require('./components/Transactions/CreateDeposit.vue').default);
Vue.component('transactions-update-withdrawal', require('./components/Transactions/UpdateWithdrawal.vue').default);
Vue.component('transactions-update-deposit', require('./components/Transactions/UpdateDeposit.vue').default);

// Reports
Vue.component('reports-bankroll-evolution', require('./components/Reports/BankrollEvolution.vue').default);
Vue.component('reports-bankroll-daily-evolution', require('./components/Reports/BankrollDailyEvolution.vue').default);
Vue.component('reports-daily-result-table', require('./components/Reports/DailyResultTable.vue').default);
Vue.component('reports-daily-result-chart', require('./components/Reports/DailyResultChart.vue').default);
Vue.component('reports-accumulated-result-chart', require('./components/Reports/AccumulatedResultChart').default);
Vue.component('reports-profit-loss-chart', require('./components/Reports/ProfitLossBetsChart').default);
Vue.component('reports-profit-loss-map-result-chart', require('./components/Reports/ProfitLossMapResultChart').default);
Vue.component('reports-tags', require('./components/Reports/TagsIndex.vue').default);
Vue.component('reports-tags-details-chart', require('./components/Reports/TagsDetailsChart.vue').default);
Vue.component('reports-tags-details-table', require('./components/Reports/TagsDetailsTable.vue').default);
Vue.component('reports-sports-compare-chart', require('./components/Reports/SportsCompareChart.vue').default);
Vue.component('reports-sports-compare-table', require('./components/Reports/SportsCompareTable.vue').default);
Vue.component('reports-odd-chart', require('./components/Reports/OddChart.vue').default);
Vue.component('reports-loss-event-table', require('./components/Reports/LossEventTable.vue').default);
Vue.component('reports-loss-event-chart', require('./components/Reports/LossEventChart.vue').default);
Vue.component('reports-multiple-chart', require('./components/Reports/MultipleChart.vue').default);
Vue.component('reports-multiple-table', require('./components/Reports/MultipleTable.vue').default);
Vue.component('reports-competition-overview-table', require('./components/Reports/CompetitionOverviewTable.vue').default);
Vue.component('reports-competition-overview-chart', require('./components/Reports/CompetitionOverviewChart.vue').default);
Vue.component('reports-competition-detail-chart', require('./components/Reports/CompetitionDetailChart.vue').default);
Vue.component('reports-competition-detail-table', require('./components/Reports/CompetitionDetailTable.vue').default);
Vue.component('reports-market-overview-chart1', require('./components/Reports/MarketOverviewChart1.vue').default);
Vue.component('reports-market-overview-chart2', require('./components/Reports/MarketOverviewChart2.vue').default);
Vue.component('reports-market-overview-chart3', require('./components/Reports/MarketOverviewChart3.vue').default);
Vue.component('reports-market-overview-table', require('./components/Reports/MarketOverviewTable.vue').default);
Vue.component('reports-market-detail-chart', require('./components/Reports/MarketDetailChart.vue').default);
Vue.component('reports-market-detail-table', require('./components/Reports/MarketDetailTable.vue').default);

// Diary
Vue.component('diary-bets-of-day-table', require('./components/Diary/DiaryBetsOfDayTable').default);
Vue.component('diary-edit', require('./components/Diary/Edit').default);

// Configurations
Vue.component('general-config-edit', require('./components/Configurations/General/Edit').default);
Vue.component('configurations-bankrolls-manager', require('./components/Configurations/Bankrolls/Index').default);
Vue.component('configurations-strategies-manager', require('./components/Configurations/Strategies/Index').default);
Vue.component('configurations-competitions-manager', require('./components/Configurations/Competitions/Index').default);
Vue.component('reset-account', require('./components/Configurations/Account/Reset').default);

// Payments
Vue.component('payments-checkout', require('./components/Payments/Checkout/Index').default);

// Profile
Vue.component('profile-edit', require('./components/Profile/Edit').default);

// Objectives
Vue.component('objective-index-table', require('./components/Objective/IndexTable').default);
Vue.component('objective-create', require('./components/Objective/Create').default);
Vue.component('objective-edit', require('./components/Objective/Edit').default);
Vue.component('objective-subview-chart1', require('./components/Objective/SubView/Chart1').default);
Vue.component('objective-subview-chart2', require('./components/Objective/SubView/Chart2').default);
Vue.component('objective-subview-chart3', require('./components/Objective/SubView/Chart3').default);
Vue.component('objective-subview-chart4', require('./components/Objective/SubView/Chart4').default);

Vue.component('objective-subview-table1', require('./components/Objective/SubView/Table1').default);
Vue.component('objective-subview-table2', require('./components/Objective/SubView/Table2').default);
Vue.component('objective-subview-table3', require('./components/Objective/SubView/Table3').default);
Vue.component('objective-subview-table4', require('./components/Objective/SubView/Table4').default);
Vue.component('objective-subview-table5', require('./components/Objective/SubView/Table5').default);
Vue.component('objective-subview-table6', require('./components/Objective/SubView/Table6').default);

// Invitation
Vue.component('invite-link', require('./components/Invite/Link').default);
Vue.component('send-invitation', require('./components/Invite/SendInvitation').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});
